import {
  authAPIRequest,
  httpRequestMethods
} from '@/cllib/axios_init'
import * as url from './ycUrl'

// depotGasWay
export function depotGasWayGetData (parm) {
  return authAPIRequest(url.depotGasWay.basUrl, httpRequestMethods.GET, parm)
}

export function depotGasWayUpdateData (parm) {
  return authAPIRequest(url.depotGasWay.basUrl, httpRequestMethods.POST, parm)
}

export function depotGasWayUpdateDataOne (parm) {
  return authAPIRequest(url.depotGasWay.basUrl, httpRequestMethods.PUT, parm)
}

export function depotGasWayUpdateDataSome (parm) {
  return authAPIRequest(url.depotGasWay.updateSome, httpRequestMethods.POST, parm)
}

// depotTank
export function depotTankGetData (parm) {
  return authAPIRequest(url.depotTank.basUrl, httpRequestMethods.GET, parm)
}

export function depotTankAddData (parm) {
  return authAPIRequest(url.depotTank.basUrl, httpRequestMethods.POST, parm)
}

export function depotTankUpdateData (parm) {
  return authAPIRequest(url.depotTank.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function depotTankDelData (id) {
  return authAPIRequest(url.depotTank.parmUrl(id), httpRequestMethods.DELETE)
}

// depotInvoicing
export function depotInvoicingGetData (parm) {
  return authAPIRequest(url.depotInvoicing.basUrl, httpRequestMethods.GET, parm)
}

export function depotInvoicingInput (parm) {
  return authAPIRequest(url.depotInvoicing.input, httpRequestMethods.POST, parm)
}

// gasDepotDraft
export function gasDepotDraftGetData (parm) {
  return authAPIRequest(url.gasDepotDraft.basUrl, httpRequestMethods.GET, parm)
}

export function gasDepotDraftPush (parm) {
  return authAPIRequest(url.gasDepotDraft.push, httpRequestMethods.POST, parm)
}

// gasDepot
export function gasDepotGetData (parm) {
  return authAPIRequest(url.gasDepot.basUrl, httpRequestMethods.GET, parm)
}

export function gasDepotOutPut (parm) {
  return authAPIRequest(url.gasDepot.outPut, httpRequestMethods.GET, parm, true)
}

// gasDepotPriority
export function gasDepotPriorityGetData (parm) {
  return authAPIRequest(url.gasDepotPriority.basUrl, httpRequestMethods.GET, parm)
}

export function gasDepotPriorityOutPut (parm) {
  return authAPIRequest(url.gasDepotPriority.outPut, httpRequestMethods.GET, parm, true)
}

// gasDepotPublish
export function gasDepotPublishGetData (parm) {
  return authAPIRequest(url.gasDepotPublish.basUrl, httpRequestMethods.GET, parm)
}



// WEBPACK FOOTER //
// ./src/api/ycApi.js